import Vue from 'vue'

export default {
  update (id, payload) {
    return Vue.http.patch(`/slotting/external_member/${id}`, payload)
  },

  getAll (config = {}) {
    return Vue.http.get('/slotting/external_member', {
      ...config
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/rental/member.js